import angular from 'angular';
import uiRouter from 'angular-ui-router';
import needALoanFamilySelectComponent from './needALoanFamilySelect.component';

let needALoanFamilySelectModule = angular.module('needALoanFamilySelect', [
  uiRouter
])

.component('needALoanFamilySelect', needALoanFamilySelectComponent)

.name;

export default needALoanFamilySelectModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/needALoanFamilySelect/needALoanFamilySelect.js